export const mes = {

  title: "SIMDO",
  //提示
  exchange_tip_content: "Are you sure to switch languages?",
  exchange_tip_title: "Tips",
  exchange_tip_confirm_btn: "Confirm",
  exchange_tip_cancel_btn: "Cancel",
  //中英文
  index_top_zh_lang_tips: '中文',
  index_top_en_lang_tips: 'English',
  //主页面
  index_top_nav_1: "Home",
  index_top_nav_2: "M-phone",
  index_top_nav_3: "Communication",
  index_top_nav_4: "Recognition",
  index_top_nav_5: "About simdo",

  index_bottom_nav_1: "Latest Products",
  index_bottom_nav_1_1: "R800 Rugged mobile phone",
  index_bottom_nav_1_2: "F60 Clamshell function machine",
  index_bottom_nav_1_3: "MM750 Red dot award-winning products",


  index_bottom_nav_2: "About simdo",
  index_bottom_nav_2_1: "Company profiles",
  index_bottom_nav_2_2: "Development history",
  index_bottom_nav_2_3: "Cooperative partner",
  index_bottom_nav_2_4: "Method of cooperation",
  index_bottom_nav_2_5: "Quality certification",

  index_bottom_nav_3: "Mobile communication",
  index_bottom_nav_3_1: "Smartphone",
  index_bottom_nav_3_2: "Rugged mobile phone",
  index_bottom_nav_3_3: "Clamshell machine",
  index_bottom_nav_3_4: "Bar machine",

  index_top_nav_log_src: "../static/img/index/log.png",
  index_top_nav_footer_src: "../static/img/index_en/footer_en.png",
  //下拉
  index_top_1: "../static/img/index_en/top8_en.png",
  index_top_2: "../static/img/index_en/top9_en.png",
  //轮播
  index_swiper_1: '../../static/img/index_en/swiper01_en.jpg',
  index_swiper_2: '../../static/img/index_en/swiper02_en.jpg',
  index_swiper_3: '../../static/img/index_en/swiper03_en.jpg',
  index_swiper_4: '../../static/img/index_en/swiper04_en.jpg',
  //签名
  index_name_text: '../../static/img/index_en/Home_word1_en.png',
  //hover块
  index_unHover_1: '../../static/img/index_en/u55_en.png',
  index_hover_1: '../../static/img/index_en/u56_en.png',
  index_unHover_2: '../../static/img/index_en/u58_en.png',
  index_hover_2: '../../static/img/index_en/u59_en.png',
  index_unHover_3: '../../static/img/index_en/u61_en.png',
  index_hover_3: '../../static/img/index_en/u62_en.png',
  index_unHover_4: '../../static/img/index_en/u64_en.png',
  index_hover_4: '../../static/img/index_en/u65_en.png',
  index_unHover_5: '../../static/img/index_en/u67_en.png',
  index_hover_5: '../../static/img/index_en/u68_en.png',
  index_unHover_6: '../../static/img/index_en/u70_en.png',
  index_hover_6: '../../static/img/index_en/u71_en.png',
  index_unHover_7: '../../static/img/index_en/u73_en.png',
  index_hover_7: '../../static/img/index_en/u74_en.png',
  index_unHover_8: '../../static/img/index_en/u76_en.png',
  index_hover_8: '../../static/img/index_en/u77_en.png',
  //
  index_four_content_img: '../../static/img/index_en/Home_word3_en.png',

  index_five_content_1_text: "../../static/img/index_en/Home_word4_en.png",
  index_five_content_2_text: "../../static/img/index_en/Home_word5_en.png",
  index_five_content_2_img: "../../static/img/index_en/Home_word6_en.png",
  index_five_content_3_img: "../../static/img/index_en/Home_word7_en.png",
  index_five_content_4_img: "../../static/img/index_en/Home_word8_en.png",
  index_five_content_5_img: "../../static/img/index_en/Home_word9_en.png",
  index_five_content_6_img: "../../static/img/index_en/Home_word10_en.png",
  index_five_content_7_img: "../../static/img/index_en/Home_word11_en.png",
  /*
  O12
  */
  first_content_1: '../../../static/img/ydtx_en/o12/O12_word1.png',
  first_content_2: '../../../static/img/ydtx_en/o12/O12_word2.png',
  first_content_3: '../../../static/img/ydtx_en/o12/O12_word3.png',

  o12_text_1: "Family number 1",
  o12_text_2: "Family number 2",
  o12_text_3: "Family number 3",

  /*
  O21
  */
  o21_first_content_1: '../../../static/img/ydtx_en/o21/021_word1.png',
  o21_first_content_2: '../../../static/img/ydtx_en/o21/021_word2.png',
  o21_second_content_1: '../../../static/img/ydtx_en/o21/021_word2_1.png',
  o21_second_content_2: '../../../static/img/ydtx_en/o21/021_word2_2.png',
  o21_third_content_1: '../../../static/img/ydtx_en/o21/021_word3_1.png',
  o21_third_content_2: '../../../static/img/ydtx_en/o21/021_word3_2.png',
  /*
  O22
  */
  o22_first_content_1: '../../../static/img/ydtx_en/o22/022_word1.png',
  o22_first_content_2: '../../../static/img/ydtx_en/o22/022_word2.png',
  o22_second_content_1: '../../../static/img/ydtx_en/o22/022_word3.png',
  o22_six_content_0: '../../../static/img/ydtx_en/o22/022_word4.png',
  o22_seven_content_0: '../../../static/img/ydtx_en/o22/022_word5.png',
  o22_eight_content_0: '../../../static/img/ydtx_en/o22/022_word6.png',
  /*
  R700
  */
  r700_first_content_1: '../../../static/img/ydtx_en/r700/r700_word1.png',
  r700_first_content_2: '../../../static/img/ydtx_en/r700/r700_word2.png',
  r700_first_content_3: '../../../static/img/ydtx_en/r700/r700_word3.png',
  r700_second_content_1: '../../../static/img/ydtx_en/r700/r700_word4.png',
  r700_third_content_1: '../../../static/img/ydtx_en/r700/r700_word5.png',
  r700_four_content_1: '../../../static/img/ydtx_en/r700/r700_word6_en.png',
  r700_four_content_3: '../../../static/img/ydtx_en/r700/r700_word7_en.png',
  r700_five_content_1: '../../../static/img/ydtx_en/r700/r700_word8_en.png',
  r700_five_content_3: '../../../static/img/ydtx_en/r700/r700_word9_en.png',
  r700_six_content_1: '../../../static/img/ydtx_en/r700/r700_word10.png',
  /*
   R800
   */
  r800_second_content_0: '../../../static/img/ydtx_en/R800/R800_bg2_en.png',
  r800_third_content_0: '../../../static/img/ydtx_en/R800/R800_bg3_en.png',
  r800_third_content_1: '../../../static/img/ydtx_en/R800/r800_word1.png',
  r800_four_content_0: '../../../static/img/ydtx_en/R800/R800_bg4_en.png',
  r800_five_content_0: '../../../static/img/ydtx_en/R800/R800_bg5_en.png',
  r800_seven_content_1: '../../../static/img/ydtx_en/R800/r800_word2.png',
  r800_eight_content_1: '../../../static/img/ydtx_en/R800/r800_word3.png',
  r800_eight_content_2: '../../../static/img/ydtx_en/R800/r800_word4.png',
  r800_nine_content_1: '../../../static/img/ydtx_en/R800/r800_word5.png',
  r800_nine_content_2: '../../../static/img/ydtx_en/R800/r800_word6.png',
  /*
   F60
   */
  f60_first_content_1: '../../../static/img/ydtx_en/F60/F60_word1_en.png',
  f60_first_content_2: '../../../static/img/ydtx_en/F60/F60_word2_en.png',
  f60_second_content_1: '../../../static/img/ydtx_en/F60/F60_word3_en.png',
  f60_second_content_2: '../../../static/img/ydtx_en/F60/F60_word4_en.png',
  f60_third_content_1: '../../../static/img/ydtx_en/F60/F60_word5_en.png',
  f60_third_content_2: '../../../static/img/ydtx_en/F60/F60_word6_en.png',
  f60_four_content_1: '../../../static/img/ydtx_en/F60/F60_word7_en.png',
  /*
   MM570
   */
  mm750_first_content_1: '../../../static/img/ydtx_en/750/750_word1_en.png',
  mm750_third_content_0: '../../../static/img/ydtx_en/750/750_word2_en.png',
  mm750_third_content_1: '../../../static/img/ydtx_en/750/750_word3_en.png',
  mm750_five_content_1: '../../../static/img/ydtx_en/750/750_word4_en.png',
  mm750_eight_content_0: '../../../static/img/ydtx_en/750/750_word5_en.png',
  /*
   H18
   */
  h18_first_content_1: '../../../static/img/zwtx_en/H18/H18_word1_en.png',
  h18_second_content_0: '../../../static/img/zwtx_en/H18/H18_word2_en.png',
  h18_third_content_1: '../../../static/img/zwtx_en/H18/H18_word3_en.png',
  h18_four_content_1: '../../../static/img/zwtx_en/H18/H18_word4_en.png',
  h18_four_content_2: '../../../static/img/zwtx_en/H18/H18_word5_en.png',
  h18_four_content_3: '../../../static/img/zwtx_en/H18/H18_word6_en.png',
  h18_five_content_1: '../../../static/img/zwtx_en/H18/H18_word7_en.png',
  h18_five_content_2: '../../../static/img/zwtx_en/H18/H18_word8_en.png',
  h18_five_content_3: '../../../static/img/zwtx_en/H18/H18_word9_en.png',
  h18_six_content_0: '../../../static/img/zwtx_en/H18/H18_word10_en.png',
  h18_six_content_1: '../../../static/img/zwtx_en/H18/H18_word11.1_en.png',
  h18_six_content_2: '../../../static/img/zwtx_en/H18/H18_word11.2_en.png',
  h18_six_content_3: '../../../static/img/zwtx_en/H18/H18_word12_en.png',
  h18_seven_content_0: '../../../static/img/zwtx_en/H18/H18_word13_en.png',
  h18_eight_content_0: '../../../static/img/zwtx_en/H18/H18_word14_en.png',
  h18_ten_content_0: '../../../static/img/zwtx_en/H18/H18_word15_en.png',
  h18_eleven_content_0: '../../../static/img/zwtx_en/H18/H18_word16_en.png',
  h18_eleven_content_1: '../../../static/img/zwtx_en/H18/H18_word17_en.png',
  h18_eleven_content_2: '../../../static/img/zwtx_en/H18/H18_word18_en.png',
  h18_twelve_content_1: '../../../static/img/zwtx_en/H18/H18_word19_en.png',
  h18_thirteen_content_0: '../../../static/img/zwtx_en/H18/H18_word20_en.png',
  h18_thirteen_content_1: '../../../static/img/zwtx_en/H18/H18_word21_en.png',
  /*
     D30
     */
  d30_first_content_1: '../../../static/img/zwtx_en/D30/D30_word1_en.png',
  d30_third_content_0: '../../../static/img/zwtx_en/D30/D30_word2_en.png',
  d30_four_content_0: '../../../static/img/zwtx_en/D30/D30_word3_en.png',

  /*
   P35
   */
  p35_first_content_1: '../../../static/img/p35_en/P35_word1_en.png',
  p35_first_content_2: '../../../static/img/p35_en/P35_word2_en.png',
  p35_first_content_3: '../../../static/img/p35_en/P35_word3_en.png',
  p35_second_content_1: '../../../static/img/p35_en/P35_word4_en.png',
  p35_second_content_2: '../../../static/img/p35_en/P35_word5_en.png',
  p35_second_content_3: '../../../static/img/p35_en/P35_word6_en.png',
  p35_four_content_0: '../../../static/img/p35_en/P35_word7_en.png',
  p35_four_content_1: '../../../static/img/p35_en/P35_word8_en.png',
  p35_six_content_1: '../../../static/img/p35_en/P35_word9_en.png',
  p35_six_content_2: '../../../static/img/p35_en/P35_word10_en.png',
  p35_six_content_3: '../../../static/img/p35_en/P35_word10.1_en.png',
  p35_six_content_4: '../../../static/img/p35_en/P35_word11_en.png',
  p35_eight_content_1: '../../../static/img/p35_en/P35_word12_en.png',
  p35_eight_content_2: '../../../static/img/p35_en/P35_word13_en.png',
  /*
   企业资讯
   */
  qyzx_first_li: "Company profiles",
  qyzx_second_li: "Development history",
  qyzx_third_li: "Cooperative partner",
  qyzx_four_li: "Method of cooperation",
  qyzx_five_li: "Quality certification",
  qyzx_six_li: "Contact us",
  qyzx_first_content_1: '../../../static/img/qyzx_en/about_us_word1_en.png',
  qyzx_second_content_0: '../../../static/img/qyzx_en/about_us_word2_en.png',
  qyzx_second_content_1: '../../../static/img/qyzx_en/about_us_word3_en.png',
  qyzx_second_content_2: '../../../static/img/qyzx_en/about_us_word4_en.png',
  qyzx_second_content_3: '../../../static/img/qyzx_en/about_us_word5_en.png',
  qyzx_third_content_0: '../../../static/img/qyzx_en/about_us_word6_en.png',
  qyzx_third_content_1: '../../../static/img/qyzx_en/about_us_word7_en.png',
  qyzx_third_content_2: '../../../static/img/qyzx_en/about_us_word8_en.png',
  qyzx_third_content_3: '../../../static/img/qyzx_en/about_us_word9_en.png',
  qyzx_four_content_0: '../../../static/img/qyzx_en/about_us_word10_en.png',
  qyzx_four_content_1: '../../../static/img/qyzx_en/about_us_word11_en.png',
  qyzx_five_content_0: '../../../static/img/qyzx_en/about_us_word12_en.png',
  qyzx_six_content_0: '../../../static/img/qyzx_en/about_us_word13_en.png',
  qyzx_six_content_1: '../../../static/img/qyzx_en/about_us_word14_en.png',
  qyzx_six_content_2: '../../../static/img/qyzx_en/about_us_word15_en.png',
  /*
   企业资讯
   */

  /*
   合作伙伴
   */
  hzhb_first_content_0: '../../../../static/img/qyzx_en/hzhb/Partner1_en.png',
  hzhb_first_content_1: '../../../../static/img/qyzx_en/hzhb/Partner2_en.png',
  /*
   合作方式
   */

  hzfs_first_content_0:'../../../../static/img/qyzx_en/hzfs/cooperation_method_word1_en.png',
  hzfs_second_text_content_1: 'Design solution for complete phone',
  hzfs_second_text_content_2: 'Provides a whole solution which includes ID design, mechanic design,hardware design, software design and production. Provides design service and technical support for customers with low cost and high efficiency. Helps customer to reduce the cost and shorten the time to launch in market to take the advantage in market.',
  hzfs_second_text_content_3: 'Provide motherboard (PCBA)',
  hzfs_second_text_content_4: 'Provides complete PCBA and helps customers to purchase, assembles and test of related materials. Provides full technical support.',
  hzfs_second_text_content_5: 'ODM',
  hzfs_second_text_content_6: 'Provides full design solution and technical support in full process based on customer requirement. Helps customer tomanage material purchasing, production and testing until mass production is going smoothly.',
  /*
   质量认证
   */
  /*
   联系我们
   */


  /**
   * 发展历程
   */


  hzfs_img_first_content_1: "../../../../static/img/qyzx_en/fzlc/development_path_word2.png",
  hzfs_img_first_content_2: "../../../../static/img/qyzx_en/fzlc/development_path_word3.png",
  hzfs_img_first_content_3: "../../../../static/img/qyzx_en/fzlc/development_path_word4.png",


  hzfs_img_second_content_1: "../../../../static/img/qyzx_en/fzlc/development_path_word7.png",
  hzfs_img_second_content_2: "../../../../static/img/qyzx_en/fzlc/development_path_word8.png",
  hzfs_img_second_content_3: "../../../../static/img/qyzx_en/fzlc/development_path_word9.png",
  hzfs_img_second_content_4: "../../../../static/img/qyzx_en/fzlc/development_path_word10.png",

  hzfs_img_third_content_1: "../../../../static/img/qyzx_en/fzlc/development_path_word13.png",
  hzfs_img_third_content_2: "../../../../static/img/qyzx_en/fzlc/development_path_word14.png",

  hzfs_img_four_content_1: "../../../../static/img/qyzx_en/fzlc/development_path_word17.png",
  hzfs_img_four_content_2: "../../../../static/img/qyzx_en/fzlc/development_path_word18.png",
  hzfs_img_four_content_3: "../../../../static/img/qyzx_en/fzlc/development_path_word19.png",
  hzfs_img_four_content_4: "../../../../static/img/qyzx_en/fzlc/development_path_word20.png",
  hzfs_img_four_content_5: "../../../../static/img/qyzx_en/fzlc/development_path_word21.png",


  // hzfs_text_first_content_1: "Cooperation with MTK and Infineon",
  // hzfs_text_first_content_2: "Established a cooperative relationship with emporia, the world's largest old man machine brand, and continued cooperation to date",
  // hzfs_text_first_content_3: "The first double-sided dual-system mobile phone is launched (MTK+ Infineon)",
  // hzfs_text_first_content_4: "F11, the first thick and thin battery mobile phone cooperated with Sang Fei, is launched",

  // hzfs_text_first_content_5: "Deep cooperation with FOXCONN",
  // hzfs_text_first_content_6: "In-depth cooperation with Konka Group",
  // hzfs_text_first_content_7: "Deep cooperation with Russian brand FLY",
  // hzfs_text_first_content_8: "Launched a new generation of elderly mobile phone CP09 with Jialantu Design Company",

  // hzfs_text_first_content_9: "In-depth cooperation with domestic first-line brands Lenovo, ZTE, Weike, etc.",
  // hzfs_text_first_content_10: "Elderly mobile phone CP09 won the IF Design Award",
  // hzfs_text_first_content_11: "Launched products in cooperation with LAVA and LEMON",
  // hzfs_text_first_content_12: "Cooperating with emporia, the old man machine was named the best-selling mobile phone in Europe",
  // hzfs_text_first_content_13: "Participated in Hong Kong Electronics Fair and Korea Consumer Electronics Show",



  // hzfs_text_second_content_1: "The first clamshell elderly machine cooperated with TCL is launched",
  // hzfs_text_second_content_2: "Simvally cooperation with German brand",
  // hzfs_text_second_content_3: "Cooperate with the hospital to launch the first industry customized product BN430.",
  // hzfs_text_second_content_4: "Launched D7000 with French elderly service agency datacet",
  // hzfs_text_second_content_5: "Participated in Hong Kong Electronics Fair and Cebit in Germany",

  // hzfs_text_second_content_6: "Simdo's first product I56 launched",
  // hzfs_text_second_content_7: "Build your own production line",
  // hzfs_text_second_content_8: "Established the first cooperation with Polish brand MAXCOM",
  // hzfs_text_second_content_9: "Participate in Hong Kong Electronics Fair and Barcelona Electronics Fair",

  // hzfs_text_second_content_10: "Participate in Hong Kong Electronics Fair and Barcelona Electronics Fair",
  // hzfs_text_second_content_11: "Build your own smartphone R&D team",
  // hzfs_text_second_content_12: "Cooperation with Spain SAIWIRELESS",
  // hzfs_text_second_content_13: "Launched new positioning and anti-fall product MIMOV",

  // hzfs_text_second_content_14: "Launched its first MTK6513 platform smartphone",
  // hzfs_text_second_content_15: "Established cooperation with China Mobile to launch its first TD customized machine",
  // hzfs_text_second_content_16: "Cooperation with French kapsys to launch KAPPHONE, the first smart elderly machine",
  // hzfs_text_second_content_17: "Participate in Hong Kong Electronics Fair",



  // hzfs_text_third_content_1: "Cooperate with some European local brands such as emporia, MAXCOM, etc.",
  // hzfs_text_third_content_2: "Launched a new generation of mobile phones for the elderly",
  // hzfs_text_third_content_3: "Launched the first base station information acquisition instrument for security and police products",
  // hzfs_text_third_content_4: "Participate in Hong Kong Electronics Fair",

  // hzfs_text_third_content_5: "The world's first smallest sphygmomanometer for mobile medical",
  // hzfs_text_third_content_6: "The second-generation base station information acquisition instrument went on the market and achieved great success in the field of security and police",
  // hzfs_text_third_content_7: "The first 3G elderly machine was launched in Europe and successfully entered the American market",
  // hzfs_text_third_content_8: "Cooperating with domestic long-term care agency Jiujiu Yikang to launch health monitoring and deployment",
  // hzfs_text_third_content_9: "An elderly mobile phone with a background service platform system for the elderly.",
  // hzfs_text_third_content_10: "Build your own mobile APP R&D team",
  // hzfs_text_third_content_11: "Participate in Hong Kong Electronics Fair",



  // hzfs_text_four_content_1: "Xinpai Technology was formally established",
  // hzfs_text_four_content_2: "The third-generation full Netcom base station information acquisition instrument is launched",
  // hzfs_text_four_content_3: "The three generations of intelligent elderly machines are equipped with a new elderly system and photoelectric",
  // hzfs_text_four_content_4: "The health monitoring function comes out",
  // hzfs_text_four_content_5: "The advent of mobile medical ECG monitoring products",
  // hzfs_text_four_content_6: "Participate in Hong Kong Electronics Fair",

  // hzfs_text_four_content_7: "The first generation of wireless signal analyzer is launched",
  // hzfs_text_four_content_8: "Participate in the Hong Kong Spring and Autumn Electronics Fair",

  // hzfs_text_four_content_9: "Customers in the field of security are constantly expanding, and the full mining instrument and signal analyzer have obtained good market feedback    ",
  // hzfs_text_four_content_10: "5G road test and wireless signal equipment are put into research and development ",
  // hzfs_text_four_content_11: "Participated in the Hong Kong Electronics Fair in Spring and Autumn",

  // hzfs_text_four_content_12: "5G supports the successful listing of NSA/SA road test",
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js